import MUIPaper, { PaperProps as MUIPaperProps } from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { FC } from 'react';

interface Props {
  shade?: 'success' | 'warning' | 'error' | 'default';
}

type PaperProps = MUIPaperProps & Props;

interface StyledPaperProps {
  $shade?: 'success' | 'warning' | 'error';
}

const StyledPaper = styled(MUIPaper, {
  shouldForwardProp: (prop) => prop !== '$shade',
})<StyledPaperProps>(({ theme, $shade }) => ({
  transition: 'box-shadow 0.7s, border 0.7s',
  border: `0.75px solid ${theme.palette.grey[200]}`,
  ...($shade && {
    boxShadow: `0px 0px 99px ${theme.palette[$shade][100]}`,
    border: `1px solid ${theme.palette[$shade][300]}`,
  }),
}));

export const Paper: FC<PaperProps> = ({ className, shade, variant = 'outlined', ...props }) => {
  const normalizedShade = shade === 'default' ? undefined : shade;

  return (
    <StyledPaper className={className} $shade={normalizedShade} variant={variant} {...props} />
  );
};
